import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import { Button, Form, Modal, Badge, Spinner, Dropdown, DropdownButton } from "react-bootstrap";
import { getCustomerResources, addResource, extendService } from "../services/resourceService";
import { getCustomerEquipments } from "../services/equipmentService";
import { getTariffsForCustomer } from "../services/tariffService";
import FormComponent from "./common/formComponent";
import { formatNumber } from "../services/util";
import FloatingAddButton from "./common/floatingAddButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PageLoading from "./common/pageLoading";
import { isSuperAdmin } from "../services/authService";
import { StyledTableCell, StyledTableRow } from "../services/tableStyles";

class CustomerResources extends FormComponent {
  state = {
    data: {
      daysToExtend: 0,
      ipV4AddressId: "",
      equipmentId: "",
    },
    customerId: this.props.match.params.id,
    errors: {},
    action: "add",
    equipments: [],
    ipV4Addresses: [],
    showAddModal: false,
    showExtensionModal: false,
    resourceToModify: {},
    loading: true,
    processing: false,
  };

  schema = {
    daysToExtend: Joi.number().min(0).max(5).required().label("Days To Extend"),
    ipV4AddressId: Joi.string().required().label("IPV4 Addresses"),
    equipmentId: Joi.string().required().label("Equipment"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    try {
      const { data: payload, ipV4Addresses, resourceToModify, action } = this.state;

      let newService = {};
      if (action === "add") {
        const { data } = await addResource(payload);
        newService = data;
      } else if (action === "extend") {
        const { data } = await extendService(payload, resourceToModify._id);
        newService = data;
      }

      ipV4Addresses.unshift(newService);
      this.setState({
        ipV4Addresses,
        showAddModal: false,
        showExtensionModal: false,
      });

      let message = "Action Completed Successfully";

      toast.success(message);
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  async componentDidMount() {
    await this.populateEquipments();
    await this.populateServices();

    if (this.state.equipments.length > 0) {
      await this.populateTariffs();
    }

    this.setState({ loading: false });
  }

  async populateEquipments() {
    const { customerId } = this.state;

    try {
      const { data: equipments } = await getCustomerEquipments(customerId);
      this.setState({ equipments });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  async populateTariffs() {
    const { customerId } = this.state;

    try {
      const { data: equipmentTariffs } = await getTariffsForCustomer(customerId);
      this.setState({ equipmentTariffs });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  async populateServices() {
    const { equipments } = this.state;

    let equipmentIds = "";
    for (var i = 0; i < equipments.length; i++) {
      const id = equipments[i]._id;
      equipmentIds += id + ",";
    }

    try {
      const { data: ipV4Addresses } = await getCustomerResources(equipmentIds);
      this.setState({ ipV4Addresses });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  handleShowAddModal = () => {
    this.setState({ showAddModal: true });
  };

  handleShowExtensionModal = (resourceToModify) => {
    const data = { ...this.state.data };
    data.equipmentId = resourceToModify.equipmentId;
    data.tariffId = resourceToModify.tariffId;
    this.setState({ data, resourceToModify, action: "extend", showExtensionModal: true });
  };

  handleClose = () => {
    // const data = { ...this.state.data };
    // data.equipmentId = "";
    // data.tariffId = "";
    // set data
    this.setState({
      showAddModal: false,
      showChangeModal: false,
      showExtensionModal: false,
    });
  };

  handleSelectEquipment = async (e) => {
    const equipmentId = e.currentTarget.value;

    if (equipmentId === "") {
      // const tariffs = [];
      // this.setState({ tariffs });
    } else {
      const { equipmentTariffs } = this.state;
      const data = { ...this.state.data };
      data.equipmentId = equipmentId;
      const tariffs = equipmentTariffs[equipmentId];
      this.setState({ data, tariffs });
    }
  };

  render() {
    const {
      ipV4Addresses,
      resourceToModify,
      equipments,
      tariffs,
      errors,
      data,
      showAddModal,
      showExtensionModal,
      loading,
      processing,
    } = this.state;
    return (
      <React.Fragment>
        {loading && <PageLoading loading={loading} />}
        {!loading && ipV4Addresses.length === 0 && <span className="float-left mt-4">No Resources to Display</span>}
        {!loading && <FloatingAddButton classes="float-right mt-2 mb-3 ml-3" onClick={this.handleShowAddModal} />}
        {!loading && ipV4Addresses.length > 0 && (
          <TableContainer component={Paper} className="mt-4">
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>IP</StyledTableCell>
                  <StyledTableCell align="right">Equipment</StyledTableCell>
                  <StyledTableCell align="right">Start Date</StyledTableCell>
                  <StyledTableCell align="right">End Date</StyledTableCell>
                  <StyledTableCell align="right">Status</StyledTableCell>
                  <StyledTableCell align="right"></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ipV4Addresses.map((ipV4Address) => (
                  <StyledTableRow key={ipV4Address._id}>
                    <StyledTableCell component="th" scope="row">
                      <kbd>{ipV4Address.ipBlock}</kbd>
                    </StyledTableCell>
                    <StyledTableCell align="right">{ipV4Address.equipment}</StyledTableCell>
                    <StyledTableCell align="right">{ipV4Address.formattedStartDate}</StyledTableCell>
                    <StyledTableCell align="right">{ipV4Address.formattedEndDate}</StyledTableCell>
                    <StyledTableCell align="right">
                      <Badge variant={`${ipV4Address.status === "Active" ? "success" : "danger"}`}>{ipV4Address.status}</Badge>
                    </StyledTableCell>
                    {ipV4Address.isLatestResource && (
                      <StyledTableCell align="right">
                        <DropdownButton className="mb-2" size="sm" id="dropdown-success-button" title="Actions">
                          {isSuperAdmin() && (
                            <Dropdown.Item onClick={() => this.handleShowExtensionModal(ipV4Address)}>Extend</Dropdown.Item>
                          )}
                          <Dropdown.Item>Set As Primary</Dropdown.Item>
                          <Dropdown.Item>Associate</Dropdown.Item>
                          <Dropdown.Item>Disassociate</Dropdown.Item>
                        </DropdownButton>
                      </StyledTableCell>
                    )}
                    {!ipV4Address.isLatestResource && <StyledTableCell align="right"></StyledTableCell>}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Modal show={showAddModal} size="md" onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add Resource</Modal.Title>
          </Modal.Header>
          <Form onSubmit={this.handleSubmit}>
            <Modal.Body>
              <React.Fragment>
                <Form.Group controlId="equipment">
                  <Form.Label>Equipment</Form.Label>
                  <Form.Control
                    as="select"
                    custom
                    name="equipmentId"
                    onChange={this.handleSelectEquipment}
                    value={data.equipmentId}
                    size="sm"
                  >
                    <option value="">Select Equipment</option>
                    {equipments.map((equipment) => (
                      <option key={equipment._id} value={equipment._id}>
                        {equipment.name} ({equipment.sn})
                      </option>
                    ))}
                  </Form.Control>
                  {errors.equipmentId && <span className="text-danger">{errors.equipmentId}</span>}
                </Form.Group>

                {tariffs && tariffs.length > 0 && (
                  <Form.Group controlId="tariff">
                    <Form.Label>Tariff</Form.Label>
                    <Form.Control
                      as="select"
                      custom
                      name="tariffId"
                      onChange={this.handleChange}
                      value={data.tariffId}
                      size="sm"
                    >
                      <option value="">Select Tariff</option>
                      {tariffs.map((tariff) => (
                        <option key={tariff._id} value={tariff._id}>
                          {tariff.title} - &#8358;{formatNumber(tariff.price)}
                        </option>
                      ))}
                    </Form.Control>
                    {errors.equipmentId && <span className="text-danger">{errors.equipmentId}</span>}
                  </Form.Group>
                )}
              </React.Fragment>
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={this.handleClose} variant="secondary">
                Close
              </Button>
              <Button disabled={this.validate() || processing} type="submit" variant="primary">
                {processing && (
                  <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
                )}
                Add
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <Modal show={showExtensionModal} size="md" onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Extend Resource Validity: {resourceToModify.tariff}</Modal.Title>
          </Modal.Header>
          <Form onSubmit={this.handleSubmit}>
            <Modal.Body>
              <React.Fragment>
                <Form.Group controlId="daysToExtend">
                  <Form.Label>Number of Days</Form.Label>
                  <Form.Control
                    name="daysToExtend"
                    onChange={this.handleChange}
                    value={data.daysToExtend}
                    size="sm"
                    type="text"
                  />
                  {errors.daysToExtend && <span className="text-danger">{errors.daysToExtend}</span>}
                </Form.Group>
              </React.Fragment>
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={this.handleClose} variant="secondary">
                Close
              </Button>
              <Button disabled={this.validate() || processing} type="submit" variant="primary">
                {processing && (
                  <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
                )}
                Extend Service
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </React.Fragment>
    );
  }
}

export default CustomerResources;
